import React, { useEffect } from 'react';
import { useAuthStore } from '../../redux';
import getNachStatusAPICall from './helpers/get-nach-status';

import AckScreen from './screens/ack-screen';
import KeepYourSmartRepayInformativeScreen from './screens/keep-your-smart-repay-informative-screen';
import ReasonForMandateCancellation from './screens/reason-for-mandate-cancellation';

import {
  NC_KEEP_YOUR_SMART_REPAY,
  NC_MANDATE_LIST,
  NC_REASON_FOR_CANCELLATION,
  NC_SUBMITTED_REQUEST,
} from './screens/nc-screen-names';
import MandateListComponent from './screens/following-mandates-will-be-cancelled';

const NachCancellationParent = ({ screenToShow = 'NONE' }) => {
  const { customerId, Authorization, customerRefNum } = useAuthStore();

  useEffect(() => {
    getNachStatusAPICall({
      customerCredentials: {
        customerId,
        Authorization,
        customerRefNum,
      },
      payload: {
        customerRefNum,
      },
      successFn: (res) => {
        console.log(res);
      },
      errorFn: (err) => {
        console.log(err);
      },
      finallyFn: () => {
        console.log('finally');
      },
    });
  }, []);

  const getScreenNameByConstant = (screenName) => {
    switch (screenName) {
      case NC_KEEP_YOUR_SMART_REPAY:
        return <KeepYourSmartRepayInformativeScreen />;
      case NC_MANDATE_LIST:
        return <MandateListComponent />;
      case NC_REASON_FOR_CANCELLATION:
        return <ReasonForMandateCancellation />;
      case NC_SUBMITTED_REQUEST:
        return <AckScreen />;
      default:
        return <></>;
    }
  };

  return <>{getScreenNameByConstant(screenToShow)}</>;
};

export default NachCancellationParent;
